import React, { Component } from 'react';
import PropTypes from 'prop-types';
// components
import { Select } from '../static/Select';
// functions
import { findOption } from 'functions/selects';

export class MissionTypeSelect extends Component {

  static propTypes = {
    value: PropTypes.any,
    gender: PropTypes.oneOf(['M', 'F']),
    onChange: PropTypes.func,
  }

  componentDidUpdate({ gender }) {
    // if the gender changes...
    if ( this.props.gender !== gender ) {
      // remap the current value across the offset change ( e.g. 12 becomes 13 )
      // by stripping the previous gender's offset and applying the new one.
      // We can't look the old value up directly in the new option set — it
      // carries the old offset and would match nothing there.
      const current = parseInt( this.props.value, 10 );
      if ( !isNaN( current ) ) {
        const remapped = current - this.getOffset( gender ) + this.getOffset( this.props.gender );
        const option = findOption( this.getOptions(), remapped );
        if ( option && option.value !== this.props.value )
          this.props.onChange( option ); // and update it
      }
    }
  }

  getOffset = gender => {
    if ( gender === 'F' )
      return 3;

    if ( gender === 'M' )
      return 2;

    return 0;
  }

  getOptions = () => {
    const offset = this.getOffset( this.props.gender );

    return [
      { value:  0 + offset, label: 'Chabad' },
      { value: 10 + offset, label: 'Frum' },
      { value: 2 + offset, label: 'Day School' },
      { value: 4 + offset, label: 'Yeshiva School' },
      { value: 12 + offset, label: 'Friendship Circle' }
    ];
  }

  getSelected = options => {
    //let ending = 0;

    //if ( this.props.gender )
    //  ending = this.props.gender === 'F' ? 3 : 2;

    const option = parseInt( this.props.value, 10 );
    
    return findOption( options, option );
  }
  
  render() {
    let options = this.getOptions();
    let selected = this.getSelected( options );

    return (
      <Select
        { ...this.props }
        value={ selected }
        options={ options } />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/selects/static/MissionTypeSelect.jsx